import SigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteSchedule = async ({ id }) => {
  const { data } = await SigliveServiceV1({ method: 'DELETE', url: `/schedule/${id}` });

  return data;
};

export default deleteSchedule;
